<template>
	<div>
		<lcsj-filter more-text="更多筛选" @search="search()">
			<template #actions><el-button plain v-if="$checkBtnPermission('/warehouse/index', 'export')" size="small" type="warning" class="el-icon-s-promotion" @click="handleExportStockWareHouse()" :loading="exportLoading">导出补货采购清单</el-button><el-button plain size="small" type="primary" :loading="snapshotLoading" class="el-icon-document-checked" @click="handleRecordSnapshot(1)">记录当前库存</el-button><el-button plain size="small" type="success" :loading="snapshotLoading" class="el-icon-document-add" @click="handleRecordSnapshot(2)">记录维护后数量</el-button></template>
			<el-form-item label="商品信息：">
				<el-cascader v-model="formInline.typeKeyId" size="small" :options="goodsTypeList" :props="cascaderProps" placeholder="请选择商品信息" clearable filterable @change="changeType"></el-cascader>
			</el-form-item>
			
			
			<el-form-item style="float: right">
				<span class="tipContent tipContent_normal">库存正常</span>
				<span class="tipContent tipContent_Warning">库存预警</span>
			</el-form-item>
			</lcsj-filter>
		<div class="content">
			<span class="content_title">
				{{ title }}
			</span>
			<div v-if="title" class="total_quantity">当前商品总数量：<strong>{{ totalQuantity }}</strong></div>
			<div class="tableData">
				<table v-loading="loading" class="highlight-table">
					<thead>
						<tr>
							<th v-for="(item, colIndex) in listTableColumns" :key="colIndex" :class="{ 'highlight-col': colIndex === activeCol, 'fixed-column': colIndex == 0 }" class="thbgcolor">
								{{ item }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(itemTr, rowIndex) in listTableData" :key="rowIndex" :class="{ 'highlight-row': rowIndex === activeRow }" @click="handleRowClick(rowIndex)">
							<td
								v-for="(item, colIndex) in itemTr"
								:key="colIndex"
								:class="{
									'fixed-column': colIndex == 0,
									'highlight-col': colIndex === activeCol,
									'highlight-cell': rowIndex === activeRow && colIndex === activeCol
								}"
								@click.stop="handleCellClick(rowIndex, colIndex)"
							>
								<span v-if="colIndex == 0" class="qiuJing">
									{{ item.qiuJing }}
								</span>
								<div v-else-if="item.quantity > 0 && item.quantity >= item.warningQuantity" style="width: 60%; display: inline-block">
									<span class="tdContentGreen" @click="handleDBCellClick(item.keyId)">
										{{ item.quantity }}
									</span>
								</div>
								<div v-else-if="item.warningQuantity > 0 && item.quantity < item.warningQuantity" style="width: 60%; display: inline-block">
									<span class="tdContentRed" @click="handleDBCellClick(item.keyId)">
										{{ item.quantity }}
									</span>
								</div>
								<div v-else-if="item.quantity === 0 && item.warningQuantity > 0 && item.quantity <= item.warningQuantity" style="width: 60%; display: inline-block">
									<span class="tdContentRed" @click="handleDBCellClick(item.keyId)">
										{{ item.quantity }}
									</span>
								</div>
								<span v-else @click="handleDBCellClick(item.keyId)">
									{{ handleZero(item.quantity) }}
								</span>

								<span v-if="isAdminRole && item.keyId != null && item.keyId.length === 32" class="el-icon-edit" @click="handleUpdateQty(item)"></span>
								<!-- <el-tooltip placement="top" v-else>
                  <div slot="content">
                    库存数量：{{ item.quantity }}
                    <br />
                    预警数量：{{ item.warningQuantity }}
                    <br />
                    常备数量：{{ item.stockQuantity }}
                  </div>
                </el-tooltip> -->
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<selectInOrOut ref="selectInOrOut"></selectInOrOut>

		<!-- 批量录入快递单号 -->
		<lcsj-dialog v-model="dialogUpdateQtyVisible" title="修改商品库存数量" width="720px" cancel-text="取消" confirm-text="确认"
			 :close-on-click-modal="false"
			 :confirm-loading="isSubmitting" @confirm="handleUpdateQtySubmit"> <span style="display: block; margin-bottom: 10px"><strong>商品库存数量:</strong></span>
			<el-input v-model="updateQtyForm.quantity" placeholder="请输入商品库存数量" type="number" min="0" step="1" @input="handleInput"></el-input></lcsj-dialog>
	<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetAllGoodsTypeTreePageList } from "@/api/baseDataApi.js";
import { GetTwoDimensionTable, ExportErWeiStockWarehouseGoods, UpdateWareHouseQty, SaveWareHouseQtySnapshot } from "@/api/storeOrderApi.js";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
import selectInOrOut from "./selectInOrOut.vue";
import { GetSystemBusinessConfigDetailByCode } from "@/api/systemApi.js";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			loading: false,
			exportLoading: false, // 导出按钮 loading
			listGoodsTypeData: [],
			formInline: {
				typeKeyId: ""
			},
			title: "",
			totalQuantity: 0,
			listTableColumns: [],
			listTableData: [],
			activeRow: null,
			activeCol: null,
			currentBatchNo: "",
			snapshotLoading: false,
			goodsTypeList: [],
			cascaderProps: {
				value: "keyId", // 绑定值的属性名
				label: "name", // 显示文本的属性名
				children: "subList", // 子节点的属性名
				checkStrictly: false, // 可以选择任意一级
				expandTrigger: "hover" // 展开方式
			},
			dialogUpdateQtyVisible: false,
			updateQtyForm: {
				keyId: "",
				quantity: 0
			},
			isAdminRole: false,
			adminRoleKeyId: "",
			exportBlockVisible: false,
			exportBlockTitle: "",
			exportBlockData: []
		};
	},
	// 注册组件
	components: {
		selectInOrOut,
		exportBlockDialog
	},
	created() {
		this.GetAllGoodsTypeTreePageList();
		this.GetSystemBusinessConfigDetailByCode();
	},
	computed: {},
	methods: {
		// 获取商品类型数据
		GetAllGoodsTypeTreePageList() {
			GetAllGoodsTypeTreePageList({})
				.then((res) => {
					if (res.code == 1) {
						this.goodsTypeList = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		changeType(value) {
			if (value && value.length > 0) {
				// 取最后一级的值作为typeKeyId
				this.formInline.typeKeyId = value[value.length - 1];
			} else {
				this.formInline.typeKeyId = "";
			}
			// 切换商品类型时重置批次，避免跨商品类型串批次
			this.currentBatchNo = "";
			if (this.formInline.typeKeyId) {
				this.search();
			} else {
				this.title = "";
				this.totalQuantity = 0;
				this.listTableColumns = [];
				this.listTableData = [];
			}
		},
		// 处理显示为0的问题
		handleZero(val) {
			if (val === 0 || val === "0") {
				return "--";
			}
			return val;
		},
		search() {
			this.loading = true;
			GetTwoDimensionTable({
				keyId: this.formInline.typeKeyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.title = res.data.title;
						this.listTableColumns = res.data.listZhuJing;
						this.listTableColumns.unshift("球镜/柱镜");
						this.listTableData = res.data.datas;
						this.totalQuantity = res.data.totalQuantity || 0;
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 记录库存盘点快照：1=维护前原数量 2=维护后数量
		handleRecordSnapshot(recordType) {
			if (!this.formInline.typeKeyId) {
				this.$message({
					type: "error",
					message: "请先选择商品信息"
				});
				return;
			}
			if (recordType === 2 && !this.currentBatchNo) {
				this.$message({
					type: "error",
					message: "请先点击「记录当前库存」"
				});
				return;
			}
			const confirmTip = recordType === 1 ? "确认记录当前库存数量？" : "确认记录维护后的库存数量？";
			this.$confirm(confirmTip, "提示", {
				type: "warning"
			})
				.then(() => {
					this.snapshotLoading = true;
					SaveWareHouseQtySnapshot({
						goodsTypeKeyId: this.formInline.typeKeyId,
						recordType: recordType,
						// 维护前不传批次（后端生成新批次），维护后传当前批次
						batchNo: recordType === 1 ? "" : this.currentBatchNo
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: res.msg || "记录成功"
								});
								if (recordType === 1) {
									this.currentBatchNo = res.data;
								}
								// 刷新总数量（维护后库存已变动）
								this.search();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.finally(() => {
							this.snapshotLoading = false;
						});
				})
				.catch(() => {});
		},
		// 双击单元格
		handleDBCellClick(keyId) {
			if (!keyId) {
				return;
			}
			this.$refs.selectInOrOut.showRecordDialog(keyId);
		},
		handleRowClick(rowIndex) {
			this.activeRow = rowIndex;
		},
		handleCellClick(rowIndex, colIndex) {
			this.activeRow = rowIndex;
			this.activeCol = colIndex;
		},
		handleExportStockWareHouse() {
			if (this.formInline.typeKeyId) {
			exportWithLoading(this, "exportLoading", () => ExportErWeiStockWarehouseGoods({ keyId: this.formInline.typeKeyId }));
			} else {
				this.$message({
					type: "error",
					message: "请选择商品信息"
				});
			}
		},
		handleUpdateQty(item) {
			this.dialogUpdateQtyVisible = true;
			this.updateQtyForm.keyId = item.keyId;
			this.updateQtyForm.quantity = item.quantity;
		},
		handleUpdateQtySubmit() {
			if (!this.updateQtyForm.keyId) {
				this.$message({
					type: "error",
					message: "请选择商品信息"
				});
				return;
			}
			if (this.updateQtyForm.quantity < 0) {
				this.$message({
					type: "error",
					message: "请输入商品库存数量"
				});
				return;
			}
			UpdateWareHouseQty(this.updateQtyForm).then((res) => {
				if (res.code == 1) {
					this.$message({
						type: "success",
						message: "修改成功"
					});
					this.dialogUpdateQtyVisible = false;
					this.search();
				} else {
					this.$message({
						type: "error",
						message: res.msg
					});
				}
			});
		},
		handleInput(value) {
			// 确保值是字符串类型
			let inputStr = String(value);

			// 移除非数字字符，只保留数字
			let newValue = inputStr.replace(/[^\d]/g, "");
			newValue = newValue.replace("e", "");
			// 处理以0开头的情况：如果0后面有数字，则保留后面的数字；如果只有0，则保留0
			if (newValue.length > 0) {
				newValue = newValue.replace(/^0+/, "");
				// 如果处理后为空字符串（说明全是0），则设置为单个0
				if (newValue === "") {
					newValue = "0";
				}
			}

			// 将处理后的值赋回给v-model绑定的变量
			this.updateQtyForm.quantity = parseInt(newValue);
		},
		GetSystemBusinessConfigDetailByCode() {
			GetSystemBusinessConfigDetailByCode({
				code: "AdminRole"
			}).then((res) => {
				if (res.code == 1) {
					let userdata = JSON.parse(localStorage.getItem("userdata"));
					if (res.data.value.includes(userdata.roleInfo.keyId)) {
						this.isAdminRole = true;
					} else {
						this.isAdminRole = false;
					}
				} else {
					this.adminRoleKeyId = "";
					this.$message({
						type: "error",
						message: res.msg
					});
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.content {
	border-radius: 10px;
	background: var(--app-surface);
	padding: 20px;
	min-height: 630px;
	text-align: center;
	margin-bottom: 20px;

	.content_title {
		font-size: 32px;
		font-weight: 700;
		display: block;
	}

	.total_quantity {
		font-size: 18px;
		font-weight: 700;
		color: var(--app-primary);
		margin-top: 8px;

		strong {
			font-size: 22px;
			color: var(--app-danger);
		}
	}

	.tableData {
		width: 100%;
		display: flex;
		margin-top: 20px;
		height: 570px;
		/* 固定容器高度 */
		overflow-y: auto;
		/* 启用垂直滚动 */

		table {
			border: 2px solid var(--app-text);
			border-radius: 5px;
			width: auto;
			min-width: 100%;
		}

		table,
		th {
			height: 25px;
			font-family: "楷体";
			font-size: 14px;
			font-weight: 600;
			min-width: 40px;
			border: 1px solid var(--app-text);
			position: sticky;
			top: 0;
			left: 0;
			/* 防止透明重叠 */
			z-index: 10;
			flex: 1;
		}

		table,
		td {
			border: 1px solid var(--app-text);
			padding: 0;
			margin: 0;
			text-align: center;
			border-collapse: collapse;
			font-size: 12px;
			font-family: "宋体";
			font-weight: 600;
		}

		.qiuJing {
			font-size: 14px;
			font-weight: 600;
			height: 25px;
			line-height: 25px;
			font-family: "楷体";
			width: 100%;
			text-align: center;
			align-items: center;
			background-color: transparent;
		}
	}

	/* 固定列样式 */
	.fixed-column {
		position: sticky;
		left: 0;
		z-index: 2;
		border-right: 2px solid var(--app-border);
		text-align: center;
		align-items: center;
		background-color: lightgray;
	}

	.thbgcolor {
		background-color: lightgray;
	}

	/* 固定列表头特殊处理 */
	thead th.fixed-column {
		z-index: 14;
		left: 0;
		background-color: lightgray;
	}

	.highlight-table {
		border-collapse: collapse;
	}

	.highlight-table th,
	.highlight-table td {
		border: 1px solid var(--app-border);
		// padding: 8px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	.highlight-row > td {
		background-color: var(--app-primary-soft);
	}

	.highlight-col {
		background-color: var(--app-primary-soft);
	}

	.highlight-cell {
		background-color: var(--app-info);
		color: black;
		font-weight: bold;
	}
}

.tdContentGreen {
	color: #04a304d8;
	font-size: 14px;
	font-family: "黑体";
	font-weight: 900;
	align-content: center;
	height: 100%;
	width: 100%;
}

.tdContentRed {
	color: var(--app-danger);
	font-size: 14px;
	font-family: "黑体";
	font-weight: 900;
	align-content: center;
	height: 100%;
	width: 100%;
}

.tipContent {
	font-size: 12px;
	font-family: "黑体";
	font-weight: 900;
	color: var(--app-text);
	align-content: center;
	text-align: center;
	width: 120px;
	height: 40px;
	display: inline-block;
	padding: 0;
}

.tipContent_normal {
	background-color: #04a304d8;
}

.tipContent_Warning {
	background-color: var(--app-danger);
}
</style>
